import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from "@mui/material";

type AlertProps = Omit<DialogProps, "maxWidth" | "fullWidth"> & {
  title: string;
  content: string;
  okTitle?: string;
  onClose: () => void;
};

export const Alert = (props: AlertProps) => {
  const { title, content, okTitle = "확인", onClose, ...other } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog {...other} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={handleClose}>
          {okTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
